export const onlyPhoneDigits = (phone: string = ''): string =>
  phone.replace(/\D/g, '').slice(0, 11);

export const formatPhone = (phone: string = ''): string => {
  const digits = onlyPhoneDigits(phone);

  if (digits.length <= 2) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }

  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
};
